import { EditorState } from 'draft-js';

import { MODAL_TYPE_TEXT_EDITOR_LINK } from '../../../constants/modal-types';
import { hasLinksInSelection, removeLinksInSelection, getFocusableContainerId } from './text-editor-utils';

const removeLinks = editorState => {
  const selection = editorState.getSelection();
  const newEditorState = removeLinksInSelection(editorState);

  return EditorState.acceptSelection(newEditorState, selection);
};

export const toggleLink = ({ editorState, identifier, openModal }) => {
  if (hasLinksInSelection(editorState)) {
    return removeLinks(editorState);
  } else {
    openModal(MODAL_TYPE_TEXT_EDITOR_LINK, { identifier }, getFocusableContainerId(identifier));
    return null;
  }
};



// WEBPACK FOOTER //
// ./app/components/text-editor/modifiers/link-modifiers.js